import { useNavigation } from '@react-navigation/native';
import { DateRangePicker, Header, Text } from '_/components';
import ContainerWidthLimit from '_/components/ContainerWidthLimit';
import { VisitItem } from '_/components/VisitItem';
import { fontFamily } from '_/config/theme';
import themes from '_/constants/themes';
import { useVisitsContext } from '_/hooks/VisitsProvider';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View, Image, ActivityIndicator, StyleSheet, FlatList } from 'react-native';

export default function VisitsHistory() {
  const { goBack } = useNavigation<any>();

  const { t: translate } = useTranslation();

  const [selectedStartDate, setSelectedStartDate] = useState<Date>();
  const [selectedEndDate, setSelectedEndDate] = useState<Date>();

  const { getVisists, visits, loading: loadingVisits } = useVisitsContext();

  function handleChangeDates(startDate: Date, endDate: Date) {
    setSelectedEndDate(endDate);
    setSelectedStartDate(startDate);
    getVisists({ startDate, endDate });
  }

  function renderHistory() {
    if (loadingVisits) {
      return (
        <View style={styles.emptyContainer}>
          <ActivityIndicator size="large" color="#222" />
        </View>
      );
    }

    if (visits.length > 0) {
      return (
        <View style={styles.content}>
          <FlatList
            data={visits}
            keyExtractor={(item) => item.id.toString()}
            renderItem={({ item }) => <VisitItem visit={item} />}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              flexGrow: 1,
              paddingHorizontal: 16,
            }}
          />
        </View>
      );
    }

    return (
      <View style={styles.emptyContainer}>
        <Text style={styles.emptyText}>{translate('home.selectDateMessage')}</Text>
        <Image source={themes.images.bigCalendar} style={styles.emptyImage} />
      </View>
    );
  }

  return (
    <ContainerWidthLimit>
      <View style={styles.container}>
        <Header handleBack={() => goBack()} title={translate('home.history')} />
        <View style={{ marginTop: 8 }}>
          <View style={styles.datePickerContainer}>
            <DateRangePicker
              selectedEndDate={selectedEndDate}
              selectedStartDate={selectedStartDate}
              handleChangeDates={handleChangeDates}
            />
          </View>
          {renderHistory()}
        </View>
      </View>
    </ContainerWidthLimit>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: themes.colors.lightQuaternary,
    flex: 1,
  },
  content: {
    flex: 1,
    marginTop: 18,
  },
  rowContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  datePickerContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 50,
    marginTop: 16,
    gap: 16,
  },
  titleContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
  },
  title: {
    color: themes.colors.darkSecondary,
    fontSize: 24,
    marginRight: 6,
  },
  lengthText: {
    color: themes.colors.darkSecondary,
    fontSize: 14,
    marginRight: 4,
  },
  expandButtonContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: 8,
  },
  expandButtonText: {
    color: themes.colors.darkQuaternary,
    fontFamily: fontFamily.medium,
    fontSize: 12,
    marginRight: 8,
  },
  emptyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    paddingVertical: 56,
    paddingHorizontal: 12,
  },
  emptyImage: {
    resizeMode: 'contain',
    flex: 1,
  },
  emptyText: {
    color: themes.colors.darkQuaternary,
    fontFamily: fontFamily.medium,
    fontSize: 16,
    marginBottom: 24,
    textAlign: 'center',
  },
  icons: {
    fontSize: 12,
    color: themes.colors.darkSecondary,
  },
  iconChevron: {
    fontSize: 14,
    color: themes.colors.darkQuaternary,
  },
});
